import React, { useContext, useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import { FaSearch, FaAngleDoubleRight, FaBars, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";
import { IoNotifications, IoPersonCircleSharp, IoLogoWhatsapp, IoSearch,IoNavigateSharp  } from "react-icons/io5";
import { IoMdMic } from "react-icons/io";
import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import { parseStoredAccessToken } from "./../parseStoredAccessToken.js";
import { parseWalletAmount } from "./../parseWalletAmount.js";
import { FormatDate } from "./../Function";
import { encryptReferralRef } from "./../referralRefCrypto.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { AuthContext } from './../AuthContext';
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import { borderRadius } from '@mui/system';
import { Navigate } from "react-router-dom";


const ShopExplorer = () => {
  const [categorydata, setcategorydata] = useState([]);
  const [productcategorydata, setproductcategorydata] = useState([]);
  const [location, setLocation] = useState([]);
  const [error, setError] = useState(null);
  const [LocationShow, setLocationShow] = useState(false);
  const [storelocation, setstorelocation] = useState(null);
  const [cityQuery, setCityQuery] = useState("");
  const [citySuggestions, setCitySuggestions] = useState([]);
  const { user, fulluser } = useContext(AuthContext);
  const [UserActivity, setUserActivity] = useState(null);
  const [Shopslist, setShopslist] = useState([]);
  const [Userecommrce, setUserecommrce] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const [newsdata, setNewsdata] = useState([]);
  const [images, setimages] = useState([]);
  const handleReferAndEarnClick = (e) => {
    e.preventDefault();
 
    if (!fulluser?.id) {
      navigate('/signin');
      return;
    }
    void shareReferralLink();
  };

  const shareReferralLink = async () => {
    let referralLink;
    try {
      const refToken = await encryptReferralRef(String(fulluser?.id ?? ''));
      referralLink = `${window.location.origin}/signup?ref=${encodeURIComponent(refToken)}`;
    } catch (err) {
      console.error('Referral link encrypt failed', err);
      alert('Could not create referral link. Please try again.');
      return;
    }

    const isInReactNativeWebView = typeof window.ReactNativeWebView !== 'undefined';

    if (navigator.share && !isInReactNativeWebView) {
      navigator
        .share({
          title: 'Join with my referral link!',
          text: 'Sign up now and get a bonus!',
          url: referralLink,
        })
        .then(() => console.log('Shared successfully'))
        .catch((error) => console.error('Sharing failed', error));
    } else if (isInReactNativeWebView) {
      // Send referralLink to React Native
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'SHARE_REFERRAL',
        url: referralLink,
      }));
    } else {
      alert('Your device does not support native sharing.');
    }
  };


  const applyCityLocation = (cityItem) => {
    const data = {
      latitude: cityItem.latitude,
      longitude: cityItem.longitude,
      address: cityItem.city,
      city: cityItem.city,
    };
    localStorage.setItem('user_location_search', JSON.stringify(data));
    setstorelocation(data);
    setLocation({
      latitude: cityItem.latitude,
      longitude: cityItem.longitude,
    });
    setCityQuery(cityItem.city);
    setCitySuggestions([]);
    setLocationShow(false);
  };

  const handleCityInputChange = async (e) => {
    const value = e.target.value;
    setCityQuery(value);
    if (value.trim().length < 1) {
      setCitySuggestions([]);
      return;
    }
    try {
      const response = await axios.get(
        `${site_url}/vendor/city-locations?q=${encodeURIComponent(value.trim())}`
      );
      if (response.data?.status === 'success') {
        setCitySuggestions(response.data.data || []);
      } else {
        setCitySuggestions([]);
      }
    } catch (err) {
      console.error('City search error:', err);
      setCitySuggestions([]);
    }
  };

const getNewsdata = async () => {
  const response = await axios.get(site_url + "/apm_news_api");
  if (response.data.status == 'success') {
    setNewsdata(response.data.data);
  }
};

  const games = [
    {
      name: "Mile Stone",
      icon: "https://pngimg.com/d/target_PNG30.png",
      reward: 100,
      bg: "radial-gradient(circle, rgb(16 198 184) 61%, rgb(10 136 153) 111%)"
    },
  ];
  const getUserdetails = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/customer_details", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          if (res.data.status == 'success') {
            setUserActivity(res.data);
            console.log(res.data);
          } else {
          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };
  const customer_ecommorce = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/customer_ecommorce", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          if (res.data.status == 'success') {
            setUserecommrce(res.data);
          } else {
          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };
  useEffect(() => {
    getUserdetails();
    customer_ecommorce();
  }, [user]);


  const [loading, setLoading] = useState(true);


  useEffect(() => {
    if (fulluser?.id) {
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [fulluser]);






  const requestLocation = () => {
    if (!("geolocation" in navigator)) {
      setLocationShow(true);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const data = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          address: 'Current location',
        };
        localStorage.setItem('user_location_search', JSON.stringify(data));
        setstorelocation(data);
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
        setLocationShow(false);
      },
      (err) => {
        setError(err.message);
        setLocationShow(true);
      }
    );
  };

  const checkuserlocation = () => {
    const stored = localStorage.getItem('user_location_search');
    if (stored) {
      try {
        const storedata = JSON.parse(stored);
        if (storedata?.latitude != null && storedata?.longitude != null) {
          setstorelocation(storedata);
          setLocation({
            latitude: storedata.latitude,
            longitude: storedata.longitude,
          });
          if (storedata.city) {
            setCityQuery(storedata.city);
          } else if (storedata.address) {
            setCityQuery(storedata.address);
          }
          setLocationShow(false);
          return;
        }
      } catch (e) {
        console.error('Invalid stored location', e);
      }
    }
    setLocationShow(true);
  };
  useEffect(() => {
    const shopcategory = async () => {
      try {
        const response = await axios.get(site_url + '/vendor/shopcategory');
        if (response.data.status == 'success') {
          setcategorydata(response.data.category);
        }
      } catch (error) {
      }
    }
    const productcategory = async () => {
      try {
        const response = await axios.get(site_url + '/vendor/productcategory');
        if (response.data.status == 'success') {
          setproductcategorydata(response.data.category);
        }
      } catch (error) {
      }
    }
    shopcategory();
    productcategory();
    checkuserlocation();
    getNewsdata();
  }, [])
  useEffect(() => {
    fetchNearbyShops(true);
  }, [storelocation, location]);
  const fetchNearbyShops = async (isRefresh = false) => {
    let currentPage = isRefresh ? 1 : page;
    let data = null;

    if (isRefresh) {
      setPage(1);
      setHasMore(true);
    }

    if (storelocation && storelocation.latitude) {
      data = {
        latitude: storelocation.latitude,
        longitude: storelocation.longitude,
        page: currentPage,
        per_page: 10
      };
    } else if (location && location.latitude) {
      data = {
        latitude: location.latitude,
        longitude: location.longitude,
        page: currentPage,
        per_page: 10
      };
    }

    if (data && data.latitude) {
      try {
        console.log('Fetching shops for page:', currentPage);
        const response = await axios.post(`${site_url}/nearbyshops`, data);
        if (response.data.status === "success") {
          if (isRefresh) {
            setShopslist(response.data.shops);
            setPage(2);
          } else {
            setShopslist((prev) => [...prev, ...response.data.shops]);
            setPage((prev) => prev + 1);
          }
          setHasMore(response.data.has_more);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    }
  };
  // const nearbyshop = async () => {
  //   let data = null; 
  //   if (storelocation) {
  //     data = {
  //       latitude: storelocation.latitude,
  //       longitude: storelocation.longitude, 
  //     };
  //   } else if (location?.latitude) {
  //     data = {
  //       latitude: location.latitude,
  //       longitude: location.longitude,
  //     };
  //   }
  //     console.log(data);
  //   if(data.latitude){
  //     try {
  //       const response = await axios.post(site_url + '/nearbyshops',data);
  //       if (response.data.status == 'success') {
  //         setShopslist(response.data.shops);
  //       }
  //     } catch (error) {
  //     }
  //   }
  //   }

  const HorizontalScrollGallery = () => {
    return (
      <div className="scroll-container">
        {productcategorydata.map((category, index) => (
          <div className='produccate'>
            <Link to={`/Productcate`} state={{ category }}>
              <img key={index} src={site_url_img + '/' + category.image} className="scroll-item" />
            </Link>
            <center><b className='scrol_img'>{category.name} </b></center>
          </div>
        ))}
      </div>
    );
  };
  const ImageSlider = () => {
    return (
      <Carousel controls={false} indicators={false} interval={3000} >
        {images.map((src, index) => (
          <Carousel.Item key={index}>
            <img className="d-block joinbanner " src={site_url_img + '/' + src.banner} />
          </Carousel.Item>
        ))}
      </Carousel>
    );
  };

  // Running Message Component
  const RunningMessage = () => {
    return (
      <div
        style={{
          background: 'linear-gradient(135deg, rgb(189 54 145) 0%, rgb(118, 75, 162) 100%)',
          color: 'white',
          padding: '12px 0',
          marginTop: '10px',
          overflow: 'hidden',
          position: 'relative',
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'inline-block',
            paddingLeft: '100%',
            animation: 'scroll-left 20s linear infinite',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          <span style={{color: 'white'}}>{newsdata.news1}</span> 
        </div>
      </div>
    );
  };
  const RunningMessageb = () => {
    return (
      <div
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '12px 0',
          marginTop: '10px',
          overflow: 'hidden',
          position: 'relative',
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'inline-block',
            paddingLeft: '100%',
            animation: 'scroll-left 20s linear infinite',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          <span style={{color: 'white'}}>{newsdata.news2}</span>
        </div>
      </div>
    );
  };
  const RunningMessagec = () => {
    return (
      <div
        style={{
          background: 'linear-gradient(135deg, #6236ff 0%, #f03 100%)',
          color: 'white',
          padding: '12px 0',
          marginTop: '10px',
          overflow: 'hidden',
          position: 'relative',
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'inline-block',
            paddingLeft: '100%',
            animation: 'scroll-left 20s linear infinite',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          <span style={{color: 'white'}}>{newsdata.news3}</span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    getBannerlist();
  }, []);
  const getBannerlist = async () => {
    const response = await axios.get(`${site_url}/bannerlist`);
    if (response.data.status == 'success') {
      setimages(response.data.bannerlist);
    }
  };
  // const images = [
  //   // "https://apmsmarthub.com/public/storage/uploads/banner/1747133090_%F0%9D%99%8A%F0%9D%99%88%F0%9D%99%82!%20%F0%9D%99%88%F0%9D%99%A4%F0%9D%99%A3%F0%9D%99%9A%F0%9D%99%AE%20%F0%9D%99%97%F0%9D%99%96%F0%9D%99%98%F0%9D%99%A0%20%F0%9D%99%A4%F0%9D%99%A3%20%F0%9D%98%BF%F0%9D%99%96%F0%9D%99%9E%F0%9D%99%A1%F0%9D%99%AE%20%F0%9D%99%80%F0%9D%99%A8%F0%9D%99%A8%F0%9D%99%9A%F0%9D%99%A3%F0%9D%99%A9%F0%9D%99%9E%F0%9D%99%96%F0%9D%99%A1%F0%9D%99%A8!!%20(3).png",
  //   // "https://apmsmarthub.com/public/storage/uploads/banner/banner_2.png",
  //   // "https://apmsmarthub.com/public/storage/uploads/banner/banner_3.png",
  //   // "https://apmsmarthub.com/public/storage/uploads/banner/banner_33.png",
  //   //  "https://apmsmarthub.com/public/storage/uploads/banner/1747133090_%F0%9D%99%8A%F0%9D%99%88%F0%9D%99%82!%20%F0%9D%99%88%F0%9D%99%A4%F0%9D%99%A3%F0%9D%99%9A%F0%9D%99%AE%20%F0%9D%99%97%F0%9D%99%96%F0%9D%99%98%F0%9D%99%A0%20%F0%9D%99%A4%F0%9D%99%A3%20%F0%9D%98%BF%F0%9D%99%96%F0%9D%99%9E%F0%9D%99%A1%F0%9D%99%AE%20%F0%9D%99%80%F0%9D%99%A8%F0%9D%99%A8%F0%9D%99%9A%F0%9D%99%A3%F0%9D%99%A9%F0%9D%99%9E%F0%9D%99%96%F0%9D%99%A1%F0%9D%99%A8!!%20(3).png",
  //   "https://admin.apmsmarthub.com/public/storage/uploads/banner/1 (2).png",
  //   "https://admin.apmsmarthub.com/public/storage/uploads/banner/2 (1).png",
  //   "https://admin.apmsmarthub.com/public/storage/uploads/banner/3 (1).png",
  //   "https://admin.apmsmarthub.com/public/storage/uploads/banner/banner_33.png",

  // ];


  // Function to get image based on name
  const getImageByName = (name) => {
    const imageMap = {
      "Credit Card": "https://cdn-icons-png.flaticon.com/512/349/349221.png", // Credit card icon
      "Phone/DTH": "https://cdn-icons-png.flaticon.com/512/724/724664.png", // Phone icon
      "Health insurance": "https://cdn-icons-png.flaticon.com/512/2966/2966486.png",
      // Add more mappings as needed
    };

    // Return mapped image if exists, otherwise return default
    return imageMap[name] || "https://cdn-icons-png.flaticon.com/512/3659/3659954.png";
  };

  // Base array - images will be set automatically based on name
  const otherBase = [
    {
      "id": 1,
      "name": "Credit Card",
      "created_at": "2025-02-21T06:04:55.000000Z",
      "updated_at": "2025-03-27T10:15:20.000000Z"
    },
    {
      "id": 2,
      "name": "Phone/DTH",
      "created_at": "2025-02-21T06:04:32.000000Z",
      "updated_at": "2025-03-27T10:15:10.000000Z"
    },
    // {
    //   "id": 3,
    //   "name": "Health insurance",
    //   "created_at": "2025-02-21T06:04:32.000000Z",
    //   "updated_at": "2025-03-27T10:15:10.000000Z"
    // },
  ];

  // Map images based on name
  const other = otherBase.map(item => ({
    ...item,
    image: getImageByName(item.name)
  }));
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const handleInputChange = async (e) => {
    const value = e.target.value;
    setQuery(value);
    if (value.length > 0) {
      try {
        const response = await axios.get(`${site_url}/suggestions?q=${encodeURIComponent(value)}`);
        setSuggestions(response.data); // Corrected here
      } catch (error) {
        console.error('Error fetching suggestions:', error);
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
    }
  };
  const handleSuggestionClick = (item) => {
    setQuery('');
    setSuggestions([]);
    if (item.type === 'vendor' && item.shop) {
      if (user != null) {
        navigate('/Shopdetails', { state: { shop: item.shop } });
      } else {
        navigate('/signin');
      }
      return;
    }
    navigate(`/Search?q=${encodeURIComponent(item.name)}`);
  };

  const suggestionLabel = (item) => {
    if (item.type === 'vendor') return 'Shop';
    if (item.type === 'product') return 'Product';
    if (item.type === 'product_category') return 'Category';
    if (item.type === 'shop_category') return 'Shop type';
    return 'Search';
  };

  const inputRef = useRef(null);
  const [showSearchBar, setShowSearchBar] = useState(false);

  const toggleSearchBar = () => {
    setShowSearchBar(prev => {
      const newState = !prev;
      setTimeout(() => {
        if (newState && inputRef.current) {
          inputRef.current.focus();
        }
      }, 100); // Small delay to ensure visibility before focusing
      return newState;
    });
  };
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-white">
        <div className="text-center">
          <img
            src="app_logo.png" // or public URL
            alt="Loading..."
            style={{ width: "170px", height: "170px" }}
          />
          <div className="mt-2">Loading...</div>
        </div>
      </div>
    );
  }

  return (

    <div id="appCapsule">
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      <Navbar expand="lg" className="navbar  ">
        <Container fluid>
          <div className="row align-items-center" style={{ width: '100%' }}>
            {/* Logo on Left Side */}
            <div className="col-auto d-flex align-items-center" style={{ paddingRight: '15px' }}>
              <img
                src="./app_logo.png"
                alt="APM Logo"
                className="app-logo"
                style={{
                  maxHeight: '50px',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>

            {/* Welcome Message on Left Side */}
            <div className="col text-left">
              <div className="d-flex align-items-center">
                <Navbar.Brand className="text-white m-0" style={{ textAlign: 'left' }}>
                  {fulluser?.username != null ? 'Hey, ' + fulluser?.username : 'Shop & Save'}
                  {fulluser?.username != null && (
                    <span style={{ fontSize: '12px', display: 'block' }}>
                      Member since {new Date(fulluser?.created_at).toLocaleDateString('en-GB')}
                    </span>
                  )}
                </Navbar.Brand>
                {user == null && (
                  <Link to="/signin" className="ms-auto" style={{ textDecoration: 'none' }}>
                    <Button
                      style={{
                        background: 'rgba(255, 255, 255, 0.2)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.5)',
                        borderRadius: '30px',
                        padding: '6px 16px',
                        fontSize: '12px',
                        fontWeight: '600',
                        color: 'white',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        transition: 'all 0.3s ease',
                        whiteSpace: 'nowrap'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <IoPersonCircleSharp style={{ fontSize: '18px' }} />
                      Login / Register
                    </Button>
                  </Link>
                )}
              </div>
            </div>

            {/* Icons on Right Side */}
            <div className="col-auto d-flex justify-content-end align-items-center gap-2" style={{ marginLeft: 'auto' }}>
              <IoSearch
                onClick={toggleSearchBar}
                className="text-white"
                style={{ fontSize: '28px', color: 'white', cursor: 'pointer' }}
              />
              <IoLogoWhatsapp
                onClick={() => window.open('https://wa.me/919845492571', '_blank')}
                className="text-white"
                style={{ fontSize: '28px', color: 'white', cursor: 'pointer' }}
              />
              <IoNavigateSharp 
              onClick={() => setLocationShow(true)}
                className="text-white"
                style={{ fontSize: '28px', color: 'white', cursor: 'pointer' }}
              />
              <IoPersonCircleSharp
                className="headerButton text-white"
                data-bs-toggle="modal"
                data-bs-target="#sidebarPanel"
                style={{ fontSize: '28px', color: 'white', cursor: 'pointer' }}
              />
            </div>
          </div>

          {/* <div className="row align-items-center justify-content-between" style={{ width: '100%' }}>
  <div className="col-3 d-flex justify-content-start">
    <IoPersonCircleSharp
      className="headerButton"
      data-bs-toggle="modal"
      data-bs-target="#sidebarPanel"
      style={{ fontSize: '30px', color: 'white' }}
    />
  </div>

<div className="col-6 d-flex justify-content-center align-items-center">
  <div className="d-flex align-items-center gap-2">
    <img src="./logo.png" alt="Logo" style={{ maxHeight: '50px' }} />
    <h3 className="text-white m-0">APM</h3>
  </div>
</div>

  
  <div className="col-3 d-flex justify-content-end gap-3">
    <IoSearch  className="headerButton" onClick={toggleSearchBar} style={{ fontSize: '30px', color: 'white' }} />
    <IoLogoWhatsapp  className="headerButton" style={{ fontSize: '40px', color: 'white' }} />
    <IoNotifications  className="headerButton" style={{ fontSize: '30px', color: 'white' }} />
  </div>
</div> */}


        </Container>
        {/* Search Bar */}
        <Container
          className={` position-relative transition-height`}
          style={{
            height: showSearchBar ? '60px' : '0px',
            overflow: 'hidden',
            transition: 'height 0.3s ease'
          }}
        >
          <div
            className="search-bar d-flex align-items-center bg-white rounded px-2"
            style={{ opacity: showSearchBar ? 1 : 0, transition: 'opacity 0.3s ease' }}
          >
            <FaSearch className="text-secondary fs-5" />
            <Form.Control
              type="text"
              value={query}
              ref={inputRef}
              onChange={handleInputChange}
              placeholder="Search shops, vendors and products"
              className="border-0 shadow-none ms-2"
            />
            <img src="assets/img/mic_home_19oct.svg" alt="mic" style={{ marginLeft: '10px' }} />
          </div>

        </Container>
        {suggestions.length > 0 && (
          <div className="suggestions-box bg-white border rounded shadow-sm position-absolute w-100" style={{ top: '100%', zIndex: 999, maxHeight: '320px', overflowY: 'auto' }}>
            {suggestions.map((item, index) => (
              <div
                key={`${item.type}-${item.name}-${index}`}
                className="p-2 suggestion-item d-flex align-items-center gap-2 border-bottom"
                style={{ cursor: 'pointer' }}
                onClick={() => handleSuggestionClick(item)}
              >
                {item.type === 'vendor' && item.shop?.shop_img && (
                  <img
                    src={`${site_url_img}/${item.shop.shop_img}`}
                    alt=""
                    style={{ width: 36, height: 36, objectFit: 'cover', borderRadius: 8 }}
                  />
                )}
                <div className="flex-grow-1 text-start">
                  {/* <span className="badge bg-primary me-1" style={{ fontSize: '10px' }}>
                    {suggestionLabel(item)}
                  </span> */}
                  <span>{item.name}</span>
                  {item.type === 'vendor' && item.shop?.address && (
                    <div className="text-muted small text-truncate" style={{ maxWidth: '260px' }}>
                      {item.shop.address}
                    </div>
                  )}
                </div>
                {item.type === 'vendor' && (
                  <FaAngleRight className="text-secondary" />
                )}
              </div>
            ))}
          </div>
        )}
      </Navbar>
      {/* Search Bar */}
      {/* Categories */}
      <Container className="mt-1">
        {user && (
          <div className=''>
            <div className="">
              <div>
                <div className="row">
                  <div className="col-4">
                    <Link to={`/Purchasedetails`} >
                      <div className="stat-box insta align-items-center justify-center">
                        <div style={{ fontSize: '11px' }} className="bonuestitle">Total Saved <br></br>(Bills)<p></p></div>
                        <div className="bonuevalue">🪙 {Math.max(0, parseWalletAmount(Userecommrce?.billorders)).toFixed(2)} &nbsp;→</div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to={`/Yearlybonus`} >
                      <div className="stat-box sundaybonues">
                        <div style={{ fontSize: '11px' }} className="bonuestitle">Life Time Reward Point Earned</div>
                        <div className="bonuevalue">🪙{Math.max(0, parseWalletAmount(UserActivity?.data?.lifetime_total)).toFixed(2)} &nbsp;→</div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link  >
                      <div className="stat-box billamountbonues align-items-center justify-center">
                        <div style={{ fontSize: '11px' }} className="bonuestitle">Points available for Redemption</div>
                        <div className="bonuevalue">🪙 {parseWalletAmount(UserActivity?.data?.redemption_total).toFixed(2)}</div>

                      </div>
                    </Link>
                  </div>
                </div>
                {/* <div className="row mt-1">
                  <div className="col-4">
                    <Link to={`/Instant`} >
                      <div className="stat-box suspended_bonus align-items-center justify-center">
                        <div className="bonuestitle">Over Flowing Amount</div>
                        <div className="bonuevalue">₹ {Userecommrce?.suspended_bonus}</div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to={`/Instant`} >
                      <div className="stat-box refbonues align-items-center justify-center">
                        <div className="bonuestitle">Cash Expried</div><br></br>
                        <div className="bonuevalue">₹ 0</div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to={`/Instant`} >
                      <div className="stat-box apm  align-items-center justify-center">
                        <div className="bonuestitle">Free Cash Gift Voucher</div>
                        <div className="bonuevalue">₹ {Userecommrce?.mile_bonus}</div>
                      </div>
                    </Link>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        )}
        <div class="container py-0">
          <Row className="align-items-center " style={{ marginTop: '5%' }}>
            <Col><h6 className="fw-bold ">Categories</h6></Col>
            <Col className="text-end">
              <Link to={'/AllCate'}> <FaAngleRight className="fs-4  sideicon-icon" /></Link>
            </Col>
          </Row>
          {user ? (
            <div>
              <Row className="mt-3 row">
                {categorydata.slice(0, 4).map((category, index) => (
                  <Col xs={3} key={index} className="mb-2 bg-white p-2" style={{ borderRadius: '16px', width: '24%', marginRight: '0.9%' }}>
                    <Link to={`/Shopcate`} state={{ category }}>
                      <center><img src={site_url_img + '/' + category.image} className="category_img" /></center>
                      <p className="category_text">{category.name}</p>
                    </Link>
                  </Col>
                ))}
              </Row>
            </div>
          ) : (
            <Row className="mt-3">
              {categorydata.slice(0, 12).map((category, index) => (
                <Col xs={3} key={index} className="mb-2">
                  <Link to={`/Shopcate`} state={{ category }}>
                    <center><img src={site_url_img + '/' + category.image} className="category_img" /></center>
                    <p className="category_text">{category.name}</p>
                  </Link>
                </Col>
              ))}
            </Row>
          )}
        </div>
        <ImageSlider />

        {/* 🔽 2 Fixed Posters After Banner - Row by Row */}

      </Container>

      {/* 🔽 Running Message Section - Full Width After Banner */}
      <RunningMessage />
      {/* Wallet Feature */}

      {/* Bills / Recharge Section - Show for both logged-in and non-logged-in users */}
      <div className='container ' style={{ marginBottom: '1%' }}>
        <h6 className="fw-bold mt-4">Bills / Recharge</h6>
        <Row className="mt-4 ">
          {other.map((category, index) => {
            // Get the correct image based on name
            const imageUrl = getImageByName(category.name);
            return (
              <Col xs={3} key={index} className="mb-2 bg-white p-3" style={{ borderRadius: '16px', marginRight: '3%' }}>
                <Link to={user ? (category.name === 'Phone/DTH' ? '/PhoneDth' : category.name === 'Credit Card' ? '/CreditCard' : `/ComingSoon?category=${category.name}`) : `/signin`} state={{ category }}>
                  <center><img src={imageUrl} className="category_img" alt={category.name} /></center>
                  <p className="category_text">{category.name}</p>
                </Link>
              </Col>
            );
          })}
        </Row>
      </div>

      {/* YouTube Video and Products - Show only for logged-in users */}
      {user ? (
        <div>
          {/* YouTube Video */}
          <div className='container mt-4 mb-3'>
            <iframe
              width="100%"
              height="200px"
              src="https://www.youtube.com/embed/udbApraAsIM"
              title="Dummy Video For Website"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              style={{ borderRadius: '16px' }}
            ></iframe>
          </div>

          <div>
            <Container className="mt-3">
              <Row className="align-items-center">
                <Col><h6 className="fw-bold">Products</h6></Col>
                <Col className="text-end"><FaAngleRight className="fs-4  sideicon-icon" /></Col>
              </Row>
              <HorizontalScrollGallery />
              {/* Fixed Poster after Products */}
              <div className="mt-3 mb-3" style={{ width: '100%', borderRadius: '16px', overflow: 'hidden' }}>
                <img
                  src="https://admin.apmsmarthub.com/public/storage/uploads/banner/banner_1.jpeg"
                  alt="Poster"
                  className="d-block"
                  style={{ width: '100%', height: 'auto', display: 'block', borderRadius: '16px' }}
                />
              </div>
            </Container>
          </div>
        </div>
      ) : (
        <div>
          <Container className="mt-3">
            <Row className="align-items-center">
              <Col><h6 className="fw-bold">Products</h6></Col>
              <Col className="text-end"><FaAngleRight className="fs-4  sideicon-icon" /></Col>
            </Row>
            <HorizontalScrollGallery />
            {/* Fixed Poster after Products */}
            <div className="mt-3 mb-3" style={{ width: '100%', borderRadius: '16px', overflow: 'hidden' }}>
              <img
                src="https://admin.apmsmarthub.com/public/storage/uploads/banner/banner_33.png"
                alt="Poster"
                className="d-block"
                style={{ width: '100%', height: 'auto', display: 'block', borderRadius: '16px' }}
              />
            </div>
          </Container>
          <Container className="mt-4">
            <Row className="align-items-center">
              <Col><h6 className="fw-bold">Near By Shops</h6></Col>
              <Col className="text-end"><FaAngleRight className="fs-4  sideicon-icon" /></Col>
            </Row>
            <Row className="mt-3 shoplist" >
              <InfiniteScroll
                dataLength={Shopslist.length}
                next={fetchNearbyShops}
                hasMore={hasMore}
                loader={<h4>Loading...</h4>}
                endMessage={<p style={{ textAlign: 'center', marginTop: '5%' }}>No more shops available</p>}
                className="row"
              >
                {Shopslist.map((shop, index) => (
                  <Col xs={6} key={index} className="">
                    <Card >
                      <Card.Body>
                        <center><img src={site_url_img + '/' + shop.shop_img} className="shoplist_img" /></center>
                        <center><span className="shoplist_text">{shop.shop_name}</span></center>
                        <p className="shoplist_dcr">{shop.address}</p>
                        <center><Link to={user != null ? `/Shopdetails` : `/signin`} state={{ shop }}><Button variant="primary">Shop Details <FaAngleRight className="fs-4  sideicon-icon_a" /></Button></Link></center>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </InfiniteScroll>
            </Row>
          </Container>
        </div>
      )}
      {/* Monthly Target Pass Card - Only show for logged-in users */}
      {user && games.map((game, index) => (
        <div>
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 * index }}
          >
            <Card className="mb-3 milesto mt-2" style={{
              border: 'none',
              borderRadius: '16px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              overflow: 'hidden',
              position: 'relative',
              marginLeft: '15px',
              marginRight: '15px',
            }}>
              <Card.Body className="justify-content-between align-items-center" style={{ padding: '20px' }}>
                <div className="d-flex align-items-start gap-3 mb-3">
                  {/* 🔹 Left: Game Icon with Modern Glassmorphic Container */}
                  {/* <div style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '16px',
                    background: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    flexShrink: 0,
                  }}>
                    <img
                      src={'./target_PNG3.png'}
                      alt={game.name}
                      style={{ width: '70px', height: '70px' }}
                    />
                  </div> */}

                  {/* 🔹 Right: Milestone Details */}
                  <div className="text-white" style={{ flex: 1 }}>
                    <span
                      className="d-inline-block mb-2"
                      style={{
                        fontSize: '12px',
                        fontWeight: 600,
                        letterSpacing: '0.06em',
                        textTransform: 'capitalize',
                        padding: '9px 12px',
                        borderRadius: '10px',
                        background: 'rgb(255 255 255)',
                        color: '#a43939',
                      }}
                    >
                      APM Monthly Bonus  Target Gate Pass Banner
                    </span>
                    <hr style={{ border: '1px solid rgba(255, 255, 255, 0.12)' ,margin: '0px 0'}}></hr>
                    <h5 className="fw-bold mb-1" style={{ fontSize: '20px', lineHeight: 1.3, margin: 0 }}>
                     
                    </h5>
                    <p className="mb-0" style={{ fontSize: '13px', opacity: 0.9, lineHeight: 1.5 }}>
                      Cross your target and earn coins from your total purchase history.
                    </p>
                    <div
                      className="d-inline-flex align-items-center gap-1 mt-3"
                      style={{
                        fontSize: '12px',
                        padding: '6px 12px',
                        borderRadius: '8px',
                        background: 'rgba(0, 0, 0, 0.12)',
                        border: '1px solid rgba(255, 255, 255, 0.12)',
                      }}
                    >
                      <span aria-hidden="true">🗓</span>
                      <span style={{ opacity: 0.85 }}>This month</span>
                      <strong>
                        {UserActivity?.data?.mile_stone_details?.from_date
                          ? FormatDate(UserActivity.data.mile_stone_details.from_date)
                          : 'N/A'}
                        {' – '}
                        {UserActivity?.data?.mile_stone_details?.to_date
                          ? FormatDate(UserActivity.data.mile_stone_details.to_date)
                          : 'N/A'}
                      </strong>
                    </div>

                    {/* Target Amount */}
                    {/* <div style={{ fontSize: '14px', opacity: 0.9 }}>
                      <strong>
                        🎯 Target: Reward Points{UserActivity?.data?.mile_stone_details?.target_amount || 0}
                      </strong>
                    </div> */}
                  </div>
                </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                  <span style={{color: 'white',fontSize: '12px'}}>Non achievers: {UserActivity?.data?.mile_stone_details?.mile_stone?.percentage_normal ?? '' }%</span>

                    <span style={{color: 'white',fontSize: '12px'}}>Achievers: {UserActivity?.data?.mile_stone_details?.mile_stone?.percentage_completed ?? '' }%</span>
                   

                  </div>
                  <center>
                  <span
  className="badge"
  style={{
    fontSize: '11px',
    backgroundColor: '#76299d',
    color: '#fff'
  }}
>
                  <p style={{color:'white'}}>
                    <b style={{marginTop: '9px'}}>🪙 1 = ₹1</b></p>
                    </span>
                    {/* <div style={{borderRadius:'10px'}} className="bttomcolor">
                      <p style={{color:'white'}}><b>🪙 1 = ₹1</b></p>
                    </div> */}
                  </center>
                <div className="mt-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <span className="text-white" style={{ fontSize: '13px', opacity: 0.9, display: 'block' }}>Current Progress</span>
                      <h4 className="text-white mb-0" style={{ fontSize: '22px', fontWeight: '700' }}>
                        ₹{UserActivity?.data?.mile_stone_details?.billamount || 0}
                      </h4>
                    </div>
                    <div className="text-end">
                      <span className="text-white" style={{ fontSize: '13px', opacity: 0.9, display: 'block' }}>Target</span>
                      <h4 className="text-white mb-0" style={{ fontSize: '22px', fontWeight: '700' }}>
                        ₹{UserActivity?.data?.mile_stone_details?.target_amount || 0}
                      </h4>
                    </div>
                  </div>
                  <div className="progress" style={{
                    height: '10px',
                    borderRadius: '10px',
                    background: 'rgba(255, 255, 255, 0.2)',
                    overflow: 'hidden'
                  }}>
                    <div
                      className="progress-bar "
                      role="progressbar"
                      style={{
                        width: `${UserActivity?.data?.mile_stone_details?.percentage || 0}%`,
                        height: '100%',
                        borderRadius: '10px',
                        transition: 'width 0.6s ease',
                        boxShadow: '0 2px 8px rgba(255, 255, 255, 0.3)'
                      }}
                      aria-valuenow={parseFloat(UserActivity?.data?.mile_stone_details?.percentage || 0).toFixed(2)}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <span className="text-white" style={{ fontSize: '12px', opacity: 0.8 }}>
                      {UserActivity?.data?.mile_stone_details?.percentage || 0}% Complete
                    </span>
                    {UserActivity?.data?.mile_stone_details?.percentage >= 100 && (
                      <span className="badge bg-success" style={{ fontSize: '11px', padding: '4px 8px' }}>
                        🎉 Target Achieved!
                      </span>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </motion.div>
        </div>
      ))}

      {/* 🔽 Running Message Section - After Target Banner */}
      <RunningMessageb />

      {/* Monthly Bonus Target — free gift bonus period (from monthly_targets table) */}
      {user && UserActivity?.data?.monthly_target_details?.status === 1 && (
        <div className="px-3 mb-3 mt-3">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35 }}
          >
            <Card
              className="border-0"
              style={{
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #e01e6d 0%,rgb(109, 14, 52) 50%,rgb(56, 16, 32) 100%)',
                boxShadow: '0 4px 20px rgba(91, 33, 182, 0.35)',
              }}
            >
              <Card.Body style={{ padding: '20px' }}>
                <h5 className="text-white fw-bold mb-2" style={{ fontSize: '18px' }}>
                 <b style={{ fontWeight: 'bold' }}>Milestone achievers GIFT Banner.</b>
                </h5>
                <p className="text-white mb-2" style={{ fontSize: '13px', opacity: 0.9 }}>Shop for ₹{UserActivity.data.monthly_target_details.target_amount}, Get {UserActivity.data.monthly_target_details.bonus_amount} 🪙.</p>
                <p className="text-white mb-2" style={{ fontSize: '13px', opacity: 0.9 }}>
                  🗓{' '}
                  {UserActivity.data.monthly_target_details.from_date
                    ? FormatDate(UserActivity.data.monthly_target_details.from_date)
                    : '—'}{' '}
                  –{' '}
                  {UserActivity.data.monthly_target_details.to_date
                    ? FormatDate(UserActivity.data.monthly_target_details.to_date)
                    : '—'}
                </p>
                

                <div className="d-flex justify-content-between text-white mb-2" style={{ fontSize: '13px' }}>
                  <span>Bonus on achieve: <strong>{UserActivity.data.monthly_target_details.bonus_amount}</strong></span>
                  <span>
                    Achievers:{' '}
                    <strong>
                      {UserActivity.data.monthly_target_details.members_achieved_count ?? 0}
                      {UserActivity.data.monthly_target_details.members_limit > 0
                        ? ` / ${UserActivity.data.monthly_target_details.members_limit}`
                        : ''}
                    </strong>
                  </span>
                </div>

                {UserActivity.data.monthly_target_details.members_limit > 0 &&
                  UserActivity.data.monthly_target_details.members_limit_reached && (
                  <div
                    className="alert alert-warning py-1 px-2 mb-2"
                    style={{ fontSize: '12px', borderRadius: '8px' }}
                  >
                    All bonus slots filled for this month. Target progress still shown below.
                  </div>
                )}

                {UserActivity.data.monthly_target_details.already_credited && (
                  <div
                    className="alert alert-success py-1 px-2 mb-2"
                    style={{ fontSize: '12px', borderRadius: '8px' }}
                  >
                    ✅ You received {UserActivity.data.monthly_target_details.bonus_amount} free gift bonus!
                  </div>
                )}

                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <span className="text-white d-block" style={{ fontSize: '12px', opacity: 0.85 }}>
                      Your purchases this month
                    </span>
                    <h4 className="text-white mb-0 fw-bold" style={{ fontSize: '22px' }}>
                    ₹ {UserActivity.data.monthly_target_details.billamount}
                    </h4>
                  </div>
                  <div className="text-end">
                    <span className="text-white d-block" style={{ fontSize: '12px', opacity: 0.85 }}>
                      Target line
                    </span>
                    <h4 className="text-white mb-0 fw-bold" style={{ fontSize: '22px' }}>
                    ₹ {UserActivity.data.monthly_target_details.target_amount}
                    </h4>
                  </div>
                </div>

                <div
                  className="progress"
                  style={{
                    height: '10px',
                    borderRadius: '10px',
                    background: 'rgba(255,255,255,0.25)',
                  }}
                >
                  <div
                    className="progress-bar bg-warning"
                    role="progressbar"
                    style={{
                      width: `${UserActivity.data.monthly_target_details.percentage || 0}%`,
                      borderRadius: '10px',
                      transition: 'width 0.5s ease',
                    }}
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <span className="text-white" style={{ fontSize: '12px', opacity: 0.9 }}>
                    {UserActivity.data.monthly_target_details.percentage || 0}% of target
                  </span>
                  {/* {(UserActivity.data.monthly_target_details.percentage || 0) >= 100 &&
                    !UserActivity.data.monthly_target_details.already_credited &&
                    !UserActivity.data.monthly_target_details.members_limit_reached && (
                    <span className="badge bg-success" style={{ fontSize: '11px' }}>
                     🪙1 Coin= ₹1(rupee one)
                    </span>
                  )} */}
                  <span className="badge bg-success" style={{ fontSize: '11px' }}>
                     🪙1 Coin= ₹1(rupee one)
                    </span>
                </div>
                <br></br>
                <p className="text-white text-center mb-2" style={{ fontSize: '17px', opacity: 0.9,fontFamily:'italic' }}>Hurry! For 1st {UserActivity.data.monthly_target_details.members_limit} members only.</p>

              </Card.Body>
            </Card>
          </motion.div>
        </div>
      )}

      <div class="container py-0" style={{ marginBottom: '5%', borderRadius: '16px' }}>
        {/* Refer & Earn Section - Only active after welcome bonus is cleared */}


        <div class="banner" style={{ marginTop: '50px' }}>
          <h2>💫𝙎𝙝𝙤𝙥𝙥𝙞𝙣𝙜 𝙂𝙪𝙞𝙙𝙚𝙡𝙞𝙣𝙚𝙨💼</h2>
          <ol>
            <li>Visit our outlets/stores <br></br>(Locaction other details available under each category.)</li>
            <li>Select the products.</li>
            <li>At Billing counter.
              Share your customer ID (10 digit Indian mobile phone number) and collect GST invoice</li>
            <li>Complete the payment only through <strong>APM SmartHub platform </strong> to enjoy all benefits.</li>
            <li>For delivery contact the store number.</li>
          </ol>
          <div class="note">
            <strong>Notes:</strong> Every amount, spent via <strong>APM SmartHub</strong> will be saved & earn unstoppable reward points.<br /><br />
            🪙 <strong>APM monthly Bonus day:</strong> On the 3rd of every following months, get flat 1% or 0.5% reward points from your total history for lifetime.
          </div>
          <div class="footer">
            💫 𝙃𝙖𝙥𝙥𝙮 𝙨𝙝𝙤𝙥𝙥𝙞𝙣𝙜! ✨
            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <strong>*T&C Apply*</strong>
            </div>
          </div>
        </div>

        {/* Refer & Earn Section */}
        
          <div className="mt-3 mb-3">
            <h5>Refer and earn</h5>
            <a
              href="#"
              onClick={handleReferAndEarnClick}
              style={{ cursor: 'pointer', display: 'block' }}
            >
              <img
                style={{ width: '100%', height: '100px', borderRadius: '16px' }}
                src='https://archliteassignment.co.uk/wp-content/uploads/2022/10/Refer-earn-banner.png'
                alt="Refer and Earn"
              />
            </a>
          </div>
       

        {/* 🔽 2 Fixed Posters After Shopping Guidelines - Row by Row */}
        {/* <div className="container mt-3 mb-3">
  <div className="d-flex flex-column gap-3">
    <img 
      src="https://apmsmarthub.com/public/storage/uploads/banner/3 (1).png" 
      alt="Poster 3" 
      style={{
        width: '100%',
        height: '120px',
        objectFit: 'cover',
        borderRadius: '16px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
    />
    <img 
      src="https://apmsmarthub.com/public/storage/uploads/banner/banner_33.png" 
      alt="Poster 4" 
      style={{
        width: '100%',
        height: '120px',
        objectFit: 'cover',
        borderRadius: '16px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
    />
  </div>
</div> */}

      </div>
      <div class="container py-0" style={{ marginBottom: '1%' }}>
        <iframe width="100%" height="200px" src="https://www.youtube.com/embed/udbApraAsIM" title="Dummy Video For Website" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

        {/* 🔽 APM Monthly Bonus Banner After Video */}
        <div className="container mt-3 mb-3">
          <Link to="/Apm">
            <img
              src="https://admin.apmsmarthub.com/public/storage/uploads/banner/banner_2.jpeg"
              alt="APM Monthly Bonus"
              style={{
                width: '100%',
                height: '150px',
                objectFit: 'cover',
                borderRadius: '16px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                cursor: 'pointer'
              }}
            />
          </Link>
        </div>
              </div>
        {/* 🔽 Running Message After APM Banner */}
        <RunningMessagec />
        <div class="container py-0" style={{ marginBottom: '14%',marginTop: '3%' }}>
        <div class="wallet-box mb-2">
          <h5 class="wallet-title">Money Back Terms & Conditions <br></br>(Loyalty points)</h5>
          <ul>
            <li>Loyalty points is applicable only on eligible purchases made via <strong>ampsmarthub App</strong>.</li>
            <li>
              GST invoice provider will be Sole responsible for quality, guarantee, warranty etc.
            </li>
            <li>Refunds will be credited back to your original mode of payment within <strong>7 working days</strong> of approval.</li>
            <li>Partial payments or transactions made outside the app are <strong>not eligible</strong>.</li>
            <li>In case of refund requests, reward points earned on that transaction will be reversed.</li>
            <li>Company reserves the right to amend or cancel the offer at any time without prior notice.</li>
            
          </ul>
        </div>

        {/* <center>
    <img src="./app_logo.png" style={{width:'150px',height:'150px'}} />
    </center> */}
        {/* <div class="text-center mb-0 mt-2">
      <h2 class="wallet-title">MY WALLET</h2>
    </div> */}
        {/* <div class="row text-center mb-2">
      <div class="col-6">
        <div class="wallet-box">
          <h4>Wallet 1</h4>
          <p><strong>Welcome Bonus wallet</strong></p>
        </div>
      </div>
      <div class="col-6">
        <div class="wallet-box">
          <h4>Wallet 2</h4>
          <p><strong>Rewards points wallet</strong></p>
        </div>
      </div>
    </div> */}
        {/* <div class="wallet-box mb-2">
      <h5 class="wallet-title">Redemption Options</h5>
      <ul>
        <li><strong>Wallet 1:</strong> Discount @ Stores only</li>
        <li><strong>Wallet 2:</strong>
          <ul>
            <li>Discount @ Stores</li> */}
        {/* <li>Payout to Bank Account (Min ₹10)</li> */}
        {/* <li>Mobile/DTH Recharge (Min ₹10)</li>
          </ul>
        </li>
      </ul>
    </div> */}
        {/* <div class="wallet-box mb-2">
      <h5 class="wallet-title">Rewards points Storage</h5>
      <div class="row">
        <div class="col-6">
          <ul>
            <li>Welcome Rewards points (App Download)</li>
            <li>Referral Rewards points</li>
            {(UserActivity?.data?.sunday_bonus_enabled !== 0) && (
            <li>Sunday/Weekly Rewards points</li>
            )}
          </ul>
        </div>
        <div class="col-6">
          <ul>
            <li>Shopping Day Rewards points</li>
            <li>APM Add-on Reward Points (7th of every month)</li>
            <li>Milestone Gifts & Vouchers</li>
            <li>Overflow Reward Points</li>
          </ul>
        </div>
      </div>
    </div> */}
        {/* <div class="wallet-box">
      <h5 class="wallet-title">Rewards points Expiry</h5>
      <ul>
        <li><strong>Welcome Rewards points wallet:</strong> 30 days</li>
        <li><strong>Rewards points wallet:</strong> 100 days</li>
      </ul>
    </div> */}
        <iframe width="100%" height="200px" src="https://www.youtube.com/embed/udbApraAsIM" title="Dummy Video For Website" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

      </div>
      {LocationShow && (
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Select Your City</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setLocationShow(false)}
                  ></button>
                </div>
                <div className="modal-body position-relative">
                  <Form.Control
                    type="text"
                    placeholder="Search city (from vendor locations)"
                    value={cityQuery}
                    onChange={handleCityInputChange}
                    autoFocus
                  />
                  {citySuggestions.length > 0 && (
                    <div
                      className="border rounded shadow-sm mt-2 bg-white"
                      style={{ maxHeight: '220px', overflowY: 'auto' }}
                    >
                      {citySuggestions.map((item, index) => (
                        <div
                          key={`${item.city}-${index}`}
                          className="p-2 border-bottom d-flex align-items-center gap-2"
                          style={{ cursor: 'pointer' }}
                          onClick={() => applyCityLocation(item)}
                        >
                          <FaMapMarkerAlt className="text-primary" />
                          <div className="flex-grow-1 text-start">
                            <div className="fw-semibold">{item.city}</div>
                            <small className="text-muted">
                              {item.vendor_count} shop(s) nearby
                            </small>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={requestLocation}
                      style={{ color: '#0078ad', textDecoration: 'none' }}
                    >
                      <FaMapMarkerAlt className="me-1" />
                      Use my current GPS location
                    </button>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setLocationShow(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
      )}
      {/* Overlay Background */}
      {LocationShow && <div className="modal-backdrop fade show"></div>}
      <Footer />
      <Sidebar />
    </div>
  );
};
export default ShopExplorer;
